import axios from "axios";
import CryptoJS from 'crypto-js';
import { v4 as uuidv4 } from 'uuid';

export const createPaymentLink = async function (txnId, amount, name, mobile, email) {
    
    const paymentData = {
        txn_id: txnId,
        amount: amount,
        name: name,
        mobile: mobile,
        email: email
    };

    try {
        const response = await axios.post('https://api-credit.entitled.co.in/utils/create-payment-insurance', paymentData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // console.log('Payment Response:', response.data);
        return response?.data
    } catch (error) {
        console.error('Error initiating payment:', error);
    }
    // const qs = require('qs');
    // let hash = generateSHA512Hash(`AWJXDQPKIG|${txnId}|${amount}|ad-hoc-payment-link|${name}|${email}|||||||||||A345GSKOUX`)
    // let data = qs.stringify({
    //     'key': 'AWJXDQPKIG',
    //     'txnid': txnId,
    //     'amount': String(amount),
    //     'productinfo': 'ad-hoc-payment-link',
    //     'firstname': name,
    //     'phone': mobile,
    //     'email': email,
    //     'surl': 'https://api-credit.entitled.co.in/',
    //     'furl': 'https://api-credit.entitled.co.in/',
    //     'show_payment_mode': 'NB,DC,CC,MW,UPI,OM,EMI,CBT,BT',
    //     'hash': hash,
    //     'sub_merchant_id': 'S1247040IJ9'
    // });
    // //console.log(data)
    // let config = {
    //     method: 'post',
    //     maxBodyLength: Infinity,
    //     url: 'https://pay.easebuzz.in/payment/initiateLink',
    //     headers: {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         'Cookie': 'Path=/'
    //     },
    //     data: data
    // };
    // let response = await axios.request(config)
    // console.log(response.data)
    // //console.log("https://pay.easebuzz.in/pay/"+response.data.data)
    // //return "https://pay.easebuzz.in/pay/"+response.data.data

}
function generateSHA512Hash(inputString) {
    // Create SHA-512 hash
    // const hash = crypto.createHash('sha512');

    // // Update hash with input string
    // hash.update(inputString, 'utf-8');
    return CryptoJS.SHA512(inputString).toString(CryptoJS.enc.Hex);

    // Get the hexadecimal digest
    // const digest = hash.digest('hex');

    // return digest;
}

// module.exports = { generateHash, createPaymentLink };